import { render } from "./Admin_Pricing_Detail.vue?vue&type=template&id=72d4d68c"
import script from "./Admin_Pricing_Detail.vue?vue&type=script&lang=js"
export * from "./Admin_Pricing_Detail.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__